import { Component, Input, ViewChild, ElementRef, OnInit, ChangeDetectorRef } from '@angular/core';
import { HttpService } from '../../../../services/dataAccess.service';
import { CoreService } from '../../../../services/core.service';
import { PropertyData, ZoomModel, ZoomRecordingFile } from '../../../../models';
import { BaseAddOnComponent } from '../base-addon.component';
import { CdkDragDrop, moveItemInArray, CdkDragStart, CdkDragEnd, CdkDrag } from '@angular/cdk/drag-drop';
import { ViewChildren } from '@angular/core';
import { QueryList } from '@angular/core';
import { AfterViewInit } from '@angular/core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-text-list',
  templateUrl: './text-list.component.html',
  styleUrls: ['./text-list.component.css', '../../dynamictag.component.css']
})

export class TextListComponent extends BaseAddOnComponent implements OnInit, AfterViewInit {

  // #region DIRECTIVES
  @Input('input') input: PropertyData;

  @ViewChildren('textearea') ElementsList: QueryList<ElementRef>;
  @ViewChild(CdkDrag) dragElement: CdkDrag;
  // #endregion

  public listTexts: Array<{ Value: string }> = [];

  // #region CONSTRUCTEUR
  constructor(
    private indParam: CoreService,
    private cd: ChangeDetectorRef,
  ) { super(); }
  // #endregion

  ngOnInit(): void {
    this.listTexts = this.input.MainElementList[0].Value.split('\n').map(v => { return { Value: v }; });
    this.cd.detectChanges();
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.ElementsList.forEach(item => {
        item.nativeElement.style.height = 'auto';
        item.nativeElement.style.height = item.nativeElement.scrollHeight + 5 + 'px';
      })
    }, 50);
  }

  public RemoveText(index: number): void {
    if (index < this.listTexts.length) {
      if (this.listTexts.length > 1) {
        this.listTexts.splice(index, 1);
      } else {
        this.listTexts[0].Value = '';
      }
    }
    this.input.MainElementList[0].Value = this.listTexts.map(v => { return v.Value; }).join('\n');
  }

  public AddText(): void {
    this.listTexts.push({ Value: '' });
  }

  public drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.listTexts, event.previousIndex, event.currentIndex);
    this.input.MainElementList[0].Value = this.listTexts.map(v => { return v.Value; }).join('\n');
  }

  public ChangeTextValue(): void {
    this.input.MainElementList[0].Value = this.listTexts.map(v => { return v.Value; }).join('\n');
  }
  public ResizeHeight(index: number, event: any): void {

    if (['Enter', 'NumpadEnter'].includes(event.code)) {
      this.listTexts.splice(index + 1, 0, { Value: '' });
      setTimeout(() => {
        this.listTexts[index].Value = this.listTexts[index].Value.replace('\n', '');
        $('#' + this.input.MainElementList[0].ID + (index + 1)).focus()
      }, 50);
    } else if (['Backspace', 'Delete'].includes(event.code)) {
      if (!this.listTexts[index].Value) {
        this.RemoveText(index);
        setTimeout(() => {
          $('#' + this.input.MainElementList[0].ID + (index > 0 ? index - 1 : 1)).focus()
        }, 50);
      }
    }
    else {
      (event.target as any).style.height = 'auto';
      (event.target as any).style.height = (event.target as any).scrollHeight + 5 + 'px';
    }
  }
  public OnDragStart(): void {
    document.body.style.setProperty('cursor', 'grabbing', 'important');
  }
  public OnDragEnd(): void {
    document.body.style.cursor = '';
  }
}
